// extracted by mini-css-extract-plugin
module.exports = {"comp":"dialog_comp__EDPbn"};